import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AgentApprovalDto, AgentDto, ApprovalRejectionReasonEnum, ImageDto } from '../../service/dto';
import { concatMap, finalize, merge, Observable, Subscription } from 'rxjs';
import { HttpAgentService } from '../../service/http-agent.service';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { HttpAgentApprovalService } from '../../service/http-agent-approval.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-agent-approval',
	standalone: false,
	templateUrl: './agent-approval.component.html',
	styleUrl: './agent-approval.component.scss'
})
export class AgentApprovalComponent implements OnInit, OnDestroy {
	subscription = new Subscription();
	id!: number;
	approval!: AgentApprovalDto;
	submitted = false;
	displayedImage?: ImageDto;
	rejectReasons: ApprovalRejectionReasonEnum[] = [
		'PortraitImageInvalid',
		'DocumentFrontImageInvalid',
		'DocumentBackImageInvalid',
		'PortraitMissMatch',
		'DataMismatch',
		'EmailNotAllowed',
		'MsisdnNotAllowed',
		'Other'
	];
	rejectReason: ApprovalRejectionReasonEnum | null = null;
	rejectComment: string = '';

	selectedViewLeft: string = 'government';
	selectedViewRight: string = 'documentFront'

	@ViewChild('rejectModal') rejectModalTemplate: any;
	@ViewChild('refGovernment', { static: true }) governmentTpl!: TemplateRef<any>;
	@ViewChild('refPortrait', { static: true }) portraitTpl!: TemplateRef<any>;
	@ViewChild('refDocumentFront', { static: true }) documentFrontTpl!: TemplateRef<any>;
	@ViewChild('refDocumentBack', { static: true }) documentBackTpl!: TemplateRef<any>;
	@ViewChild('refGovernmentPhoto', { static: true }) governmentPhotoTpl!: TemplateRef<any>;
	@ViewChild('refGovernmentPassport', { static: true }) governmentPassportTpl!: TemplateRef<any>;

	constructor(
		private service: HttpAgentApprovalService,
		private activatedRoute: ActivatedRoute,
		private sanitizer: DomSanitizer,
		private modalService: NgbModal) { }


	ngOnInit(): void {
		this.submitted = false;
		this.subscription.add(
			this.activatedRoute.paramMap.pipe(
				concatMap(item => item.get('agentId') == null ? this.service.getNext() : this.service.getAgent(+item.get('agentId')!)),
				finalize(() => this.submitted = true))
				.subscribe((result) => {
					this.approval = result;
				})
		);
	}
	private fetchApproval(input: ParamMap): Observable<AgentApprovalDto> {
		const approvalId = input.get('approvalId') == null ? null : +input.get('approvalId')!;
		const agentId = input.get('agentId') == null ? null : +input.get('agentId')!;

		if (approvalId == null && agentId == null) {
			return this.service.getNext();
		}
		if (approvalId == null) {
			return this.service.get(approvalId!);
		}
		return this.service.getAgent(agentId!);
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	get portraitImageUrl(): SafeUrl {
		return this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + this.approval.agent.portraitImage!.imageData);
	}
	get documentFrontImageUrl(): SafeUrl {
		return this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + this.approval.agent.documentFrontImage!.imageData);
	}
	get documentBackImageUrl(): SafeUrl {
		return this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + this.approval.agent.documentBackImage!.imageData);
	}

	get governmentPhotoImageUrl(): SafeUrl {
		return this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + this.approval.agent.governmentPhotoImage!.imageData);
	}
	get governmentPassportPhotoImageUrl(): SafeUrl {
		return this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + this.approval.agent.governmentPassportImage!.imageData);
	}

	get displayedImageUrl(): SafeUrl {
		return this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + this.displayedImage!.imageData);
	}


	doApprove() {
		this.service.doApprove(this.approval).subscribe(result => this.approval = result);
	}
	doReject() {
		this.rejectReason = null;
		this.rejectComment = '';
		this.modalService.open(this.rejectModalTemplate, { centered: true });

	}
	doSkip() {
		this.service.doSkip(this.approval).subscribe(result => this.approval = result);
	}


	submitReject(modal: any) {
		this.approval.reason = this.rejectReason!;
		this.approval.comment = this.rejectComment;
		modal.close();
		this.service.doReject(this.approval).subscribe(result => this.approval = result);
	}
	getTemplate(view: string): TemplateRef<any> | null {
		switch (view) {
			case 'government': return this.governmentTpl;
			case 'portrait': return this.portraitTpl;
			case 'documentFront': return this.documentFrontTpl;
			case 'documentBack': return this.documentBackTpl;
			case 'governmentPhoto': return this.governmentPhotoTpl;
			case 'governmentPassport': return this.governmentPassportTpl;
			default: return null;
		}
	}
}
